import React from "react";
import { provider } from "react-ioc";
import ThemeProvider from "./theme/ThemeProvider";

const AppProvider = ({ children }) => <ThemeProvider>{children}</ThemeProvider>;
export default provider()(AppProvider);
